import React from "react";
import SelectInput from "../inputs/SelectInput";

interface SelectPropertyFieldProps {
  value: string;
  onChange: (value: any) => void;
  options?: Array<{ value: string; label: string }>;
  placeholder?: string;
}

export default function SelectPropertyField({
  value,
  onChange,
  options = [],
  placeholder = "Selecione uma opção...",
}: SelectPropertyFieldProps) {
  const [localValue, setLocalValue] = React.useState(value || "");

  React.useEffect(() => {
    setLocalValue(value || "");
  }, [value]);

  const handleChange = (newValue: string) => {
    setLocalValue(newValue);
    // Salvar apenas o value simples
    onChange({ value: newValue });
  };

  return (
    <div className="space-y-2">
      <label className="block text-xs font-medium text-gray-700 mb-1">
        Valor
      </label>
      <SelectInput
        value={localValue}
        onChange={handleChange}
        options={[
          { value: "", label: placeholder },
          ...options,
        ]}
      />
    </div>
  );
}

